import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, map } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

export type DiseaseModule = 'blight' | 'downy-mildew' | 'virus-monitor';

interface ModuleActivationResponse {
  isActivated: boolean;
}

/**
 * Provides module-activation information for the current customer across
 * disease-monitoring features (Blight, Downy Mildew, Virus Monitor).
 */
@Injectable({
  providedIn: 'root',
})
export class CustomerRightsService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly arableDiseaseIntegrationUrl = `${this.env.APIM_BASE_URL}/arable-disease-integration-service`;

  getModuleActivation(module: DiseaseModule, cropYear?: number): Observable<boolean> {
    return this.http
      .get<ModuleActivationResponse>(`${this.arableDiseaseIntegrationUrl}/customer/is-activated`, {
        params: {
          module,
          ...(cropYear == null ? {} : { cropYear }),
        },
      })
      .pipe(map((response) => response.isActivated));
  }
}
